export default __webpack_public_path__ + "static/media/smoove_logo.0a489872.png";